(function () {
  function getSelectedVariantId() {
    return document.querySelector(".product-variant-id")?.value || "";
  }

  function getProductTitle() {
    return (
      document.querySelector(".product__title h1")?.textContent?.trim() ||
      document.querySelector("h1")?.textContent?.trim() ||
      document.title
    );
  }

  function findFieldByPlaceholder(root, placeholderText) {
    if (!root) return null;
    const wanted = String(placeholderText).trim().toLowerCase();
    const inputs = root.querySelectorAll("input, textarea, select");
    for (const el of inputs) {
      const ph = (el.getAttribute("placeholder") || "").trim().toLowerCase();
      if (ph === wanted) return el;
    }
    return null;
  }

  function populateFieldsInPanel(panelEl) {
    if (!panelEl) return;

    const variantId = getSelectedVariantId();
    const productTitle = getProductTitle();

    const variantInput =
      findFieldByPlaceholder(panelEl, "Variant ID") ||
      panelEl.querySelector('input[name*="variant"]') ||
      panelEl.querySelector('input[id*="variant"]');

    const productInput =
      findFieldByPlaceholder(panelEl, "Product Title") ||
      panelEl.querySelector('input[name*="product"]') ||
      panelEl.querySelector('input[id*="product"]');

    if (variantInput && variantId) {
      variantInput.value = variantId;
      variantInput.dispatchEvent(new Event("input", { bubbles: true }));
      variantInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (productInput && productTitle) {
      productInput.value = productTitle;
      productInput.dispatchEvent(new Event("input", { bubbles: true }));
      productInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function populateWithRetries(panelEl) {
    [150, 350, 700, 1200, 2000].forEach((ms) => {
      setTimeout(() => populateFieldsInPanel(panelEl), ms);
    });
  }

  function init() {
    document.addEventListener(
      "click",
      function (e) {
        const btn = e.target.closest(".bis__toggle");
        if (!btn) return;

        e.preventDefault();

        const wrap = btn.closest(".bis");
        const panel = wrap ? wrap.querySelector(".bis__panel") : null;
        if (!panel) return;

        const isOpen = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!isOpen));
        panel.classList.toggle("is-open", !isOpen);

        if (!isOpen) populateWithRetries(panel);
      },
      true
    );

    document.addEventListener("change", function (e) {
      if (
        e.target.name === "id" ||
        e.target.closest("variant-selects") ||
        e.target.closest("variant-radios")
      ) {
        document.querySelectorAll(".bis__panel.is-open").forEach(populateWithRetries);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
